var SecureMessageWidget = require('./../secure-message/SecureMessageWidget'),
    SecureMessageBillView = require('./SecureMessageBillView');

var VIEW_NAME = 'billsPaidListWidget';

/**
 * Customizations to the SecureMessageWidget specific to the paid bills list page.
 * @class BillsPaidListWidget
 * @constructor
 * @extends SecureMessageWidget
 */
module.exports = SecureMessageWidget.extend({
  moduleNamespace: VIEW_NAME,

  headerMessageKey: VIEW_NAME + '.header',
  noDataMessageKey: VIEW_NAME + '.noMessages',
  loadingMessageKey: VIEW_NAME + '.loading',
  fetchFailedMessageKey:  VIEW_NAME + '.fetchFailed',

  itemView: SecureMessageBillView,

  /**
   * The MixedMessageCriteria selecting the messages to display.
   *
   * @property criteria {Object}
   *   @property criteria.isPatient {Boolean} username restrictions apply to patient usernames only.
   *   @property criteria.vecnaIds {Array} Array of vecnaId restrictions
   *   @property criteria.billCriteria {Object} BillMessageCriteria - restrictions on bill messages.
   *     @property criteria.billCriteria.billCriteria {Object} restrictions on the bill itself.
   *       @property criteria.billCriteria.billCriteria.current {Boolean} only show the latest version of each bill.
   *       @property criteria.billCriteria.billCriteria.show {String} only show bills that are marked by the inbound integration as showable.
   *       @property criteria.billCriteria.billCriteria.statuses {String} only show bills with status 'PAID'.
   */
  criteria: {
    billCriteria: {
      billCriteria: {
        current: true,
        show: true,
        statuses: [ 'PAID' ]
      }
    },
    isPatient: true,
    vecnaIds: null,
    pagingAndSorting: {
      pageNumber: 0,
      orderingMap: {
        actionDate: false
      },
      pageSize: 7
    }
  }
});
